import CampaignReportBudgetLimitation from './CampaignReportBudgetLimitation';

export default CampaignReportBudgetLimitation;
